import { Dates } from 'context/DateProvider/DateProvider';
import { Filters } from 'context/FilterProvider/types/Filters';

const DELIMITER = ',';
const SEARCH_TERM = 'searchTerm';

export const emptyFilters: Filters = {
  environment: [],
  publisher: [],
  formatSize: [],
  status: [],
  resolution: [],
  frameId: [],
};

export const emptyDates: Dates = {
  from: '',
  to: '',
};

export const toFilters = (searchParams: URLSearchParams): Filters => {
  const filters: Filters = { ...emptyFilters };
  Object.keys(filters).forEach((key) => {
    filters[key as keyof Filters] = searchParams.get(key)?.split(DELIMITER) || [];
  });
  return filters;
};

export const toFiltersSearchParams = (filters: Filters): URLSearchParams => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value && value.length) {
      params.set(key, value.join(DELIMITER));
    }
  });
  return params;
};

export const toDates = (searchParams: URLSearchParams): Dates => {
  const dates: Dates = { ...emptyDates };
  Object.keys(dates).forEach((key) => {
    const value = searchParams.get(key);
    if (value) {
      // Handle "+" symbol not being read correctly
      dates[key as keyof Dates] = decodeURIComponent(value).replace(/ /g, '+');
    } else {
      dates[key as keyof Dates] = '';
    }
  });
  return dates;
};

export const toDatesSearchParams = (dates: Dates): URLSearchParams => {
  const params = new URLSearchParams();
  Object.entries(dates).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  return params;
};

export const toSearchTerm = (searchParams: URLSearchParams): string | null => {
  return searchParams.get(SEARCH_TERM);
};

export const toSearchTermSearchParams = (searchTerm: string): URLSearchParams => {
  const params = new URLSearchParams();
  params.append(SEARCH_TERM, searchTerm);
  return params;
};
